module.exports = __webpack_public_path__ + "img/grid.724a9990.svg";